<template>
  <template v-if="!hasInfo">
    <a class="vm-card" @click="submitBtn.click()">
      <div class="vm-card__logo">ER</div>
      <div class="vm-card__user">
        {{ vmLink.slice(vmLink.indexOf("://") + 3, vmLink.indexOf(".")) }}   
      </div>
      <post-form
        @emitRefs="(button) => (submitBtn = button)"
        :action="vmLink"
        :nameIdentifier="$msal.accounts[0].localAccountId"
        :cmd="'login'"
      />
    </a>
  </template>
  <a v-else class="vm-card" @click="submitBtn.click()">
    <div class="vm-card__logo">
      <img
        v-if="this.logo && this.logo.includes(';base64,')"
        :src="this.logo"
      />

      <template v-else>{{ this.logo }}</template>
    </div>
    <div
      class="vm-card__user"
      :class="{
        'vm-card__vmlink': this.company && this.company.includes('https://'),
      }"
    >
      {{ this.company }}
    </div>
    <post-form
      @emitRefs="(button) => (submitBtn = button)"
      :action="vmLink"
      :nameIdentifier="$msal.accounts[0].localAccountId"
      :cmd="'login'"
    />
  </a>
</template>

<script>
import PostForm from "@/components/PostForm.vue";

export default {
  components: { PostForm },
  props: {
    vmLink: String,
  },
  data() {
    return {
      submitBtn: null,
      company: null,
      logo: null,
      request_url: null,
      hasInfo: false,
    };
  },
  async mounted() {
    this.getAvailablity();
  },
  methods: {
    async getAvailablity() {
      this.request_url =
        this.vmLink +
        "/server.py?cmd=lib.webnotes.utils.login_with_azure_ad_b2c.get_company_name_logo";
      try {
        const response = await this.fetching(this.request_url);
        const data = await response.json();
        this.company = data.message["company"];

        this.logo = data.message["logo"];
        if (response) this.hasInfo = true;
      } catch (error) {
        this.company = this.vmLink.slice(
          this.vmLink.indexOf("://") + 3,
          this.vmLink.indexOf(".")
        );
        this.hasInfo = false;
      }
    },
    async fetching(resource, options = {}) {
      const { timeout = 8000 } = options;
      // options.;
      const controller = new AbortController();
      const id = setTimeout(() => controller.abort(), timeout);
      const response = await fetch(resource, {
        ...options,
        signal: controller.signal,
        // headers: {
        //   "Access-Control-Allow-Origin": "*",
        //   "Access-Control-Allow-Headers":
        //     "Origin, X-Requested-With, Content-Type, Accept, Authorization",
        // },
      });
      clearTimeout(id);
      return response;
    },
  },
};
</script>

<style lang="scss" scoped>
.vm-card__logo {
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: contain;
  }
}
</style>